export default {
    empty: 'This field is required.',
		formSending: 'A problem came up while sending the form.',
    no_date_selected: 'No date selected',
    no_file_selected: 'No file selected',
    pattern: 'The field [FIELD] is invalid.'
}